// HomePage → BoardPage handoff for "create new board from template X".
//
// Flow:
//   1. HomePage's template picker writes `pendingTemplateFor(boardId, id)`.
//   2. HomePage navigates to /b/{boardId}.
//   3. useBoardDoc, after IndexedDB replay, checks the pending key. If set
//      AND the board's shapes Y.Map is empty, it seeds from the template
//      and clears the marker. If the board ALREADY has shapes (the user
//      hit refresh on an already-seeded board), the pending marker is also
//      cleared — it was already consumed conceptually.
//
// Storage layout: one localStorage key per pending board so concurrent
// "new board" flows from multiple tabs don't trample each other.

const PREFIX = 'frame-pending-template:';

function key(boardId: string): string {
  return PREFIX + boardId;
}

export function setPendingTemplate(boardId: string, templateId: string): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(key(boardId), templateId);
  } catch {
    // Storage full or unavailable — fall back to "no template" (a blank board
    // will appear, the user can pick again from settings post-hoc).
  }
}

export function readPendingTemplate(boardId: string): string | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    return localStorage.getItem(key(boardId));
  } catch {
    return null;
  }
}

export function clearPendingTemplate(boardId: string): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(key(boardId));
  } catch {
    // ignore
  }
}
